module.exports = __webpack_public_path__ + "static/media/x-icon-popup.aa6ee78f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x-icon-popup.svg
// module id = 464
// module chunks = 0 1